export const GET_USER_STRIPE_CUSTOMER_REQUEST = 'GET_USER_STRIPE_CUSTOMER_REQUEST'
export const GET_USER_STRIPE_CUSTOMER_FAILURE = 'GET_USER_STRIPE_CUSTOMER_FAILURE'
export const GET_USER_STRIPE_CUSTOMER_SUCCESS = 'GET_USER_STRIPE_CUSTOMER_SUCCESS'
export const RESET_STRIPE_CUSTOMER_REQUEST = 'RESET_STRIPE_CUSTOMER_REQUEST'
